import React, {useEffect} from 'react'
import cls from './Desktop.module.scss'
import {Header} from '../widgets/Header/Header'

import {Footer} from '../widgets/Footer/Footer'
import {Outlet} from 'react-router-dom'

export const Desktop = () => {

    useEffect(() => {
        const preventTouchMove = (event) => {
            if (event.touches.length > 1 || event.targetTouches[0].pageX !== event.targetTouches[0].clientX) {
                event.preventDefault()
            }
        }

        document.addEventListener('touchmove', preventTouchMove, {passive: false})

        return () => {
            document.removeEventListener('touchmove', preventTouchMove)
        }
    }, [])
    return (
        <div className={cls.wrapper}>
            <div className={cls.Desktop}>
                <Header/>
                <Outlet/>
                <Footer/>
            </div>
        </div>
    )
}
